import { class_type } from "../Docs/fable_modules/fable-library.3.7.1/Reflection.js";

export class Header {
    constructor() {
    }
}

export function Header$reflection() {
    return class_type("Feliz.TanStack.Table.Header.Header", void 0, Header);
}

export function Header_getLeafHeaders_315F98D7(header) {
    return header.getLeafHeaders();
}

export function Header_isPlaceholder_315F98D7(header) {
    return header.isPlaceholder;
}

//# sourceMappingURL=Header.fs.js.map
